<template>
  <v-row class="entry-body py-4">
    <div class="timeline__container">
      <div class="timeline__dot"></div>
    </div>
    <div>
      <v-img
        :src="require('data/assets/work_experience/' + company.image_path)"
        :alt="company.name"
        width="65px"
        height="65px"
      ></v-img>
    </div>
    <v-col>
      <v-row align="center" class="entry-company py-0 px-4">
        <div>
          <div class="text-h6">{{ company.name }}</div>
          <v-row class="ma-0 pa-0">
            <span>{{ position }}</span>
            <span class="dot-spacer">•</span>
            <span class="entry-duration">{{ duration }}</span>
          </v-row>
        </div>
      </v-row>
      <v-expand-transition>
        <v-row v-if="active" class="entry-description py-0 px-4 mt-4">
          <div class="ml-6">
            <ul>
              <li
                v-for="(descriptionEntry, i) in description"
                v-html="descriptionEntry"
                class="entry"
                :key="i"
              ></li>
            </ul>
          </div>
          <div class="stack-icon__container" id="scrollToMe">
            <tech-stack-icon
              v-for="(stack, i) in stacks"
              :key="i"
              :stack="stack"
            />
          </div>
        </v-row>
      </v-expand-transition>
    </v-col>
    <div class="entry-company__expand-icon">
      <v-btn
        flat
        outlined
        icon
        class="pa-0"
        density="comfortable"
        @click="toggleActive()"
        :aria-expanded="active"
        :aria-label="company.name"
      >
        <v-icon>{{ active ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </div>
  </v-row>
</template>

<script>
import TechStackIcon from '@/components/utilities/TechStackIcon.vue';

export default {
  components: { TechStackIcon },
  props: {
    company: {
      name: String,
      image_path: String,
    },
    position: String,
    description: String,
    duration: String,
    stacks: Array,
  },

  data: () => ({
    active: false,
  }),

  methods: {
    autoScroll() {
      const elem = this.$el.getElementsByClassName('entry-description')[0];
      if (!elem) return;
      const dimensions = elem.getBoundingClientRect();
      if (dimensions.top < 100) {
        window.scrollBy(0, -100);
      } else if (dimensions.top + dimensions.height > window.innerHeight) {
        elem.scrollIntoView();
      }
    },

    toggleActive() {
      this.active = !this.active;
      if (this.active) {
        setTimeout(() => this.autoScroll(), 200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.entry-body {
  margin-left: 10px;
  border-left: 2px solid lightgrey;
}

.timeline__container {
  height: 65px;
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.dot-spacer {
  padding: 0 10px;
}

.entry-duration {
  font-style: italic;
  opacity: 0.6;
  white-space: nowrap;
}

.timeline__dot {
  border-radius: 50em;
  border: 2px solid grey;
  background-color: white;
  width: 14px;
  height: 14px;
  margin-left: -8px;
  margin-right: 5px;
}

.entry-company {
  align-items: center;
  min-height: 65px;
}

.entry-company__position {
  opacity: 0.8;
  font-style: italic;
}

.entry-company__expand-icon {
  align-items: center;
  display: flex;
  height: 65px;
}

.stack-icon__container {
  font-size: 2em;
  width: 100%;
}

.entry-description {
  // for mobile view
  min-width: 250px;
}
</style>
